import { createTheme, Theme } from '@mui/material/styles';
import { palette } from './palette';
import { lightPalette } from './lightPalette';
import { typography } from './typography';
import { components } from './components';

/**
 * Create theme based on mode (light or dark)
 * @param mode - 'light' or 'dark'
 * @returns Material-UI theme object
 */
export const createAppTheme = (mode: 'light' | 'dark'): Theme => {
  const selectedPalette = mode === 'light' ? lightPalette : palette;

  return createTheme({
    palette: selectedPalette,
    typography,
    components,

    // Shape configuration
    shape: {
      borderRadius: 8,
    },

    // Spacing configuration (default is 8px)
    spacing: 8,

    // Breakpoints (Material-UI defaults, can be customized)
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },

    // Transitions
    transitions: {
      duration: {
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,
        enteringScreen: 225,
        leavingScreen: 195,
      },
      easing: {
        easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
        easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
        easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
        sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
      },
    },

    // Z-index values
    zIndex: {
      mobileStepper: 1000,
      fab: 1050,
      speedDial: 1050,
      appBar: 1100,
      drawer: 1200,
      modal: 1300,
      snackbar: 1400,
      tooltip: 1500,
    },
  });
};

// Default export for backward compatibility (dark theme)
export const theme = createAppTheme('dark');
export default theme;
